import { render, staticRenderFns } from "./bothLine.vue?vue&type=template&id=f799c580&scoped=true&"
import script from "./bothLine.vue?vue&type=script&lang=js&"
export * from "./bothLine.vue?vue&type=script&lang=js&"
import style0 from "./bothLine.vue?vue&type=style&index=0&id=f799c580&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f799c580",
  null
  
)

export default component.exports